import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../SharedComponents";

interface IPreADayPensionDetailsProps extends IProcessComponentProps {
    data: DrawdownModel;
}

interface IPreADayPensionDetailsState {}

export class PreADayPensionDetails extends ProcessComponent<IPreADayPensionDetailsProps, IPreADayPensionDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                {SectionHeader("Pre-A-Day pension details")}
                <RadiosEditor
                    label={
                        "Does your client have pension, drawdown or annuity that started before 6 April 2006 that you have not informed us of previously?"
                    }
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => onChange({ PreADay: v })}
                    selected={data?.PreADay}
                    required={"Please select"}
                    cssWrapper="rg-inline mb-10"
                />
            </>
        );
    }
}
